import React, { useEffect, useState } from "react";
import { func, string } from "prop-types";
import UploadFile from "../UploadFile";
import Button from "antd/lib/button";
import SkeletonComponent from "../SkeletonComponent";
import "./WaitingDocuments.module.scss";
import { getWaitingPieces } from "Services/Pieces";
import { createTaskForEvidences, uploadAndUpdateDocument } from "../../services/Pieces";
import {
    notificationError,
    notificationSuccess,
    notificationWarning
} from "Utilities/notifications"
import { buildKiamoTaskBodyForEvidence } from "../../utils/Documents";

function WaitingDocuments({
    retrieveDocuments,
    policyId,
    personId,
    codeProduit
}) {
    const [awaitedDocuments, setAwaitedDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isDocumentsWaiting, setIsDocumentsWaiting] = useState(true)
    const [isUploading, setIsUploading] = useState(false);
    const [fileList, setFileList] = useState([]);
    
    const service = `${RELATION_CLIENT_KIAMO_SERVICEID_EVIDENCE}`;
    
    useEffect(() => {
        initWaitingDocuments();
    }, []);

    const initWaitingDocuments = () => {
        setLoading(true)
        getWaitingPieces(policyId)
            .then(data => {
                // SIP-1733 pwyd - Espace client - PDC recto/verso
                let waitingPieceCPCO = data.find(data => data.type.code === 'CPCO')
                if(waitingPieceCPCO != null) {
                    waitingPieceCPCO.type.label = "Copie du permis de conduire (recto et verso)"
                }
                setAwaitedDocuments(data)
                haveDocumentsWaiting(data)
            })
            .catch(err => {
                console.error("Aucun document trouvé :", err);
                setAwaitedDocuments([]);
            })
            .finally(() => setLoading(false));
    };

    const haveDocumentsWaiting = data => {
        let indice = false;
        for(const element of data) {
            if (element.status.label === "WAITING") {
                indice = true;
                break;
            }
        }
        indice ? setIsDocumentsWaiting(true) : setIsDocumentsWaiting(false);
    }

    const onFinishUpload = (status) => {
        if (status) {
            initWaitingDocuments();
        }
    }; 

  const handleUpload = () => {
    setIsUploading(true);
    let promises = []
    fileList.forEach(file => { 
        const formData = new FormData();
        formData.append("file", file.file)
        promises.push(uploadAndUpdateDocument(policyId, file.idDoc, formData, false))
    })
    setFileList([]);
    Promise.allSettled(promises).then(results => {
        onFinishUpload(true);
        setIsUploading(false);
        let errors = 0
        results.forEach(result => {
            const { value } = result
            if (value.status >= 300) {
                errors++ 
                if (value.status === 409) {
                    notificationWarning("Le fichier existe déjà en GED !");
                }
            }
        })
        if (results.some(result => result.value.status < 300)) {
            createTaskForEvidences(service, buildKiamoTaskBodyForEvidence(personId, policyId, codeProduit))
        } else {
            notificationError("Aucune pièce n'a été envoyée. Veuillez recommencer.")
        }

        if(errors > 0 && errors < results.length) {
            notificationError("Certaines pièces n'ont pas été envoyées. Veuillez recommencer.")
        }

        if(errors === 0) {
            notificationSuccess("Toutes les pièces ont bien été envoyées.")
        }
    })
  }

    const waitingDocs = awaitedDocuments.filter((doc) => doc.status.label === "WAITING");

    return (
        <div className="waitingDocumentsContainer">
            <SkeletonComponent
                loading={loading}
                onErrorsClick={retrieveDocuments}
            >
                <div>
                    {isDocumentsWaiting ? <h4 className="title">Merci de déposer les documents suivants pour finaliser votre souscription :</h4> : <h4 className="emptyWaitingDocument">Aucun document en attente.</h4>}
                    <div className="awaitedBlock">
                        {
                            waitingDocs.map((awaitedDocument, index) => {
                                return <div className="awaitedDocument" key={index}>
                                    {awaitedDocument.type.label}
                                    <UploadFile
                                        idDoc={awaitedDocument.id}
                                        fileList={fileList}
                                        setFileList={setFileList}
                                    />
                                </div>
                            })
                        }
                    </div>
                    {waitingDocs.length > 0 && 
                    <div className="submitPJ">
                        <Button
                            className="submitPJButton"
                            type="secondary"
                            onClick={handleUpload}
                            loading={isUploading}
                            disabled={fileList.length === 0}
                        >
                          Envoyer
                        </Button>
                    </div>
                    }
                </div>
            </SkeletonComponent>
        </div>
    );

}

WaitingDocuments.propTypes = {
    retrieveDocuments: func,
    personId: string.isRequired,
    refresh: func,
    policyId: string.isRequired,
    codeProduit: string.isRequired,
};

export default WaitingDocuments;